import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {ProfileReference} from '@github-ui/profile-reference'
import {PinIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import styles from './PinnedByBadge.module.css'

type PinnedByBadgeProps = {
  pinnedByLogin: string
}

export function PinnedByBadge({pinnedByLogin}: PinnedByBadgeProps) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()

  return (
    <span className={styles.PinnedByContainer}>
      {' '}
      &middot;
      <PinIcon size={12} className={styles.PinnedByIcon} /> Pinned by{' '}
      <Link
        href={`/${pinnedByLogin}`}
        {...getHovercardAttributesForType('user', {login: pinnedByLogin})}
        className={styles.PinnedByLink}
      >
        <ProfileReference login={pinnedByLogin} isAgent={false} />
      </Link>
    </span>
  )
}
